<template>
<div class="user-recommendations_ure">

  <page-header>
    <nav-inner :use-user-links="true"/>
  </page-header>
  <router-link
    class="help-link help-link_pcr"
    :to="{ path: '/help/21'}"
    target="_blank">
    Подробнее о рекомендациях в разделе Помощь
  </router-link>

  <div class="page-container">

    <objects-search
      nothingFoundText="На данный момент для вас нет ни одной рекомендации."/>

  </div>

  <page-footer/>

</div>
</template>

<script>
import PageHeader from '../PageHeader';
import PageFooter from '../PageFooter';
import NavInner from '../NavInner';
import ObjectsSearch from './ObjectsSearch';

export default {

  components: { PageHeader, PageFooter, NavInner, ObjectsSearch },

  data() {
    return {
      afterAdd: false,
      userId: '',
    };
  },

  created() {
    this.userId = this.$store.getters['user/getUserId'];
    this.$route.query.authorId = this.userId;
  },

};
</script>

<style lang="scss">
.user-recommendations_ure {
  .page-container {
    margin-bottom: 30px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/layouts/UserRecommendations.vue